import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LocalStorageService } from 'ngx-webstorage';

import { ApplicationConfigService } from './application-config.service';
import { Login } from '../models/login.model';

type JwtToken = {
  id_token: string;
};

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(private http: HttpClient, private localStorageService: LocalStorageService, private applicationConfigService: ApplicationConfigService) {}

  public getToken(): string | null {
    return <string>this.localStorageService.retrieve('authenticationToken');
  }

  public login(credentials: Login): Observable<void> {
    return this.http.post<JwtToken>(this.applicationConfigService.getEndpointFor('api/authenticate'), credentials).pipe(map(response => this.authenticateSuccess(response)));
  }

  public loginImpersonate(credentials: Login): Observable<void> {
    return this.http
      .post<JwtToken>(this.applicationConfigService.getEndpointFor('api/authenticate-externalnodes'), credentials)
      .pipe(map(response => this.authenticateSuccess(response)));
  }

  public logout(): Observable<void> {
    return new Observable(observer => {
      this.localStorageService.clear('authenticationToken');
      observer.complete();
    });
  }

  private authenticateSuccess(response: JwtToken): void {
    const jwt = response.id_token;
    this.localStorageService.store('authenticationToken', jwt);
  }
}
